import axios from "axios";
import constant from "../../constant";
import router from "../../router";

const api = constant.api + "";
const url = constant.url + "";

const state = () => ({
  authentications: [],
  user: JSON.parse(localStorage.getItem(constant.currentUser)) || {},
  usernaneError: "",
  passwordError: "",
  error: "",
  userRole: localStorage.getItem(constant.userRoleKey) || "",
  settings: JSON.parse(localStorage.getItem(constant.appSettings)) || [],
});

const getters = {
  user: (state) => state.user,
  getAuthData: (state) => state.user,
  getUsernaneError: (state) => state.usernaneError,
  getPasswordError: (state) => state.passwordError,
  getError: (state) => state.error,
  getAllAuthentications: (state) => state.authentications,
  getUserRole: (state) => state.userRole,

  // Dynamic getter for settings
  getSetting: (state) => (key) => {
    return localStorage.getItem(key) !== null
      ? JSON.parse(localStorage.getItem(key))
      : (state.settings.find((setting) => setting.key === key) &&
          state.settings.find((setting) => setting.key === key).value) ||
          null;
  },

  // Loop through all settings keys and return them dynamically
  allSettings: (state) => {
    const settingsObject = {};
    state.settings.forEach((setting) => {
      settingsObject[setting.key] = setting.value;
    });
    return settingsObject;
  },
};

const actions = {
  async login({ commit }, data) {
    try {
      this._vm.$loading.start(); // Start loading when action begins

      await axios.get(url + "sanctum/csrf-cookie");

      const response = await axios.post(api + "auth/login", data);
      const { status, message, username, user, settings, token } =
        response.data;

      switch (status) {
        case "usernameError":
          commit("SET_USERNAME_ERROR", message);
          commit("SET_PASSWORD_ERROR", "");
          break;

        case "passwordError":
          commit("SET_PASSWORD_ERROR", message);
          commit("SET_USERNAME_ERROR", "");
          break;

        case "error":
          commit("SET_ERROR", message);
          commit("SET_USERNAME_ERROR", "");
          commit("SET_PASSWORD_ERROR", "");
          break;

        case "confirmationCode":
          router.push({ name: "login-confirmation-code", query: { username } });
          break;

        /*
        case "success":
          // Set data in localStorage
          localStorage.setItem(
            constant.authToken,
            JSON.stringify(token)
          );
          localStorage.setItem(constant.currentUser, JSON.stringify(user));

          // Loop through settings and store each key-value pair in localStorage
          settings.forEach((setting) => {
            localStorage.setItem(
              setting.key,
              setting.valueType === "json"
                ? JSON.parse(setting.value)
                : setting.value
            );
          });

          // Store settings object as well
          localStorage.setItem(constant.appSettings, JSON.stringify(settings));

          // Update Vuex state
          commit("SET_TOKEN", token);
          commit("SET_USER", user);
          commit("SET_SETTINGS", settings);

          if (user.role) {
            await commit("SET_USER_ROLE", user.role.fullName);
            await commit("SYNC_STATE_WITH_LOCAL_STORAGE");
          }
 
          setTimeout(() => {
            router.push({ name: "dashboard" });
          }, 1000);

          break;*/

        case "success":
          // Set data in localStorage
          localStorage.setItem(constant.authToken, JSON.stringify(token));
          localStorage.setItem(constant.currentUser, JSON.stringify(user));

          // 🔐 Vérification ici avant d'utiliser settings
          if (Array.isArray(settings)) {
            settings.forEach((setting) => {
              localStorage.setItem(
                setting.key,
                setting.valueType === "json"
                  ? JSON.parse(setting.value)
                  : setting.value
              );
            });

            localStorage.setItem(
              constant.appSettings,
              JSON.stringify(settings)
            );
            commit("SET_SETTINGS", settings);
          }

          // Update Vuex state
          commit("SET_TOKEN", token);
          commit("SET_USER", user);

          if (user.role) {
            await commit("SET_USER_ROLE", user.role.fullName);
            await commit("SYNC_STATE_WITH_LOCAL_STORAGE");
          }

          setTimeout(() => {
            window.location.replace("/dashboard");
            // router.push({ name: "dashboard" });
          }, 1000);

          break;
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      this._vm.$loading.stop(); // Stop loading regardless of success or failure
    }
  },

  syncStateWithLocalStorage({ commit }) {
    commit("SYNC_STATE_WITH_LOCAL_STORAGE");
  },

  async validateConfirmationCode({ commit }, data) {
    try {
      const response = await axios.post(api + "auth/confirmation/code", data);
      const { status, message, user } = response.data;

      if (status === "success") {
        // Set data in localStorage
        localStorage.setItem(constant.authToken, JSON.stringify(token));
        localStorage.setItem(constant.currentUser, JSON.stringify(user));

        // Update Vuex state
        commit("SET_TOKEN", token);
        commit("SET_USER", user);
        commit("SYNC_STATE_WITH_LOCAL_STORAGE");

        if (user.role) {
          commit("SET_USER_ROLE", user.role.fullName);
          router.push({ name: "dashboard" });
        } else {
          router.push({ name: "dashboard" });
        }
      }
    } catch (error) {
      console.error("Error while validating confirmation code", error);
    }
  },

  async resendConfirmationCode({ commit }, data) {
    try {
      this._vm.$loading.start();

      const response = await axios.post(
        api + "auth/confirmation/code/resend",
        data
      );
      const { status, message } = response.data;

      commit("notification/store", { status, message }, { root: true });
    } catch (error) {
      console.error("Resend confirmation code error:", error);
    } finally {
      this._vm.$loading.stop();
    }
  },

  async logout({ commit }) {
    localStorage.removeItem(constant.currentUser);
    localStorage.removeItem(constant.authToken);
    localStorage.removeItem(constant.userRoleKey);

    // Update state
    commit("SET_USER", {});
    commit("SET_USER_ROLE", "");

    await router.push({ name: "login" });
  },

  fetchAllAuthentications({ commit }) {
    axios
      .get(api + "auth")
      .then((response) => {
        commit("SET_ALL_AUTHENTICATIONS", response.data);
      })
      .catch((error) => {
        console.error("Error fetching authentications:", error);
      });
  },
};

const mutations = {
  SYNC_STATE_WITH_LOCAL_STORAGE(state) {
    const userStr = localStorage.getItem(constant.currentUser);
    const roleStr = localStorage.getItem(constant.userRoleKey);
    const tokenStr = localStorage.getItem(constant.authToken);
    const settingsStr = localStorage.getItem(constant.appSettings);

    if (userStr) {
      state.user = JSON.parse(userStr);
    }

    if (roleStr) {
      state.userRole = roleStr;
    }

    if (settingsStr) {
      state.settings = JSON.parse(settingsStr);
    }
  },

  SET_USER_ROLE(state, value) {
    state.userRole = value;
    localStorage.setItem(constant.userRoleKey, value);
  },

  SET_USER(state, value) {
    state.user = value;
    localStorage.setItem(constant.currentUser, JSON.stringify(value));
  },

  SET_SETTINGS(state, value) {
    state.settings = value;
    localStorage.setItem(constant.appSettings, JSON.stringify(value));
  },

  SET_TOKEN(state, value) {
    localStorage.setItem(constant.authToken, JSON.stringify(value));
  },

  SET_USERNAME_ERROR(state, value) {
    state.usernaneError = value;
  },

  SET_PASSWORD_ERROR(state, value) {
    state.passwordError = value;
  },

  SET_ERROR(state, value) {
    state.error = value;
  },

  SET_ALL_AUTHENTICATIONS(state, value) {
    state.authentications = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
